<template>
  <!-- <div
    id="live-main"
    class="live-wrapper"
    :class="{ video: !isVideo, switch: switchPptVideo, fullscreen: fullscreen }"
  > -->
  <div
    id="live-main"
    class="live-wrapper"
    :class="{
      default: !switchPptVideo,
      switch: switchPptVideo,
      fullscreen: fullscreen,
      video: isVideo,
    }">
    <!-- 白板PPT区 -->
    <div id="whiteboard" class="live-whiteboard">
      <div class="placeholder"></div>
      <template v-if="living">
        <div class="pre-page" @click="pagePrevTrigger">上一页</div>
        <div class="next-page" @click="pageNextTrigger">下一页</div>
      </template>
    </div>
    <!-- 教师播放区 -->
    <div id="teacher-player" class="live-player">
      <!-- <video id="playback-player"></video> -->
      <div id="bplayer-container" class="bplayer-container"></div>
    </div>
    <!-- 回放控制条 -->
    <div class="playback-panel" v-show="!living">
      <!-- 播放暂停 -->
      <div class="playback-play">
        <Icon
          v-if="!isPlaying"
          type="md-play"
          title="播放"
          @click="togglePlay" />
        <Icon v-else type="md-pause" title="暂停" @click="togglePlay" />
      </div>
      <div class="playback-slider">
        <!-- <div
          v-show="switchPptVideo || fullscreen"
          id="playback-playslider"
        ></div> -->
        <div id="playback-playslider"></div>
      </div>
      <div class="playback-volume">
        <Icon type="md-volume-up" title="音量" @click="toggleVolumeSlider" />
        <div
          v-show="showVolumeSlider"
          id="playback-volume"
          class="volume-slider"></div>
      </div>
      <!-- 倍速 -->
      <div class="playback-speed">
        <div class="speed-list">
          <div class="speed-item">
            <span @click="switchSpeed(2)">2.0X</span>
            <span @click="switchSpeed(1.5)">1.5X</span>
            <span @click="switchSpeed(1.25)">1.25X</span>
            <span @click="switchSpeed(1)">1.0X</span>
            <span @click="switchSpeed(0.5)">0.5X</span>
          </div>
        </div>
        <div class="speed-text">
          {{
            currentSpeed === 1.25
              ? currentSpeed.toFixed(2)
              : currentSpeed.toFixed(1)
          }}X
        </div>
      </div>
      <!-- 清晰度 -->
      <div class="playback-quality">
        <div class="quality-list">
          <div class="quality-item">
            <span
              v-for="(item, index) in qualityList"
              :key="index"
              @click="switchQuality(item)"
              >{{ item.name }}</span
            >
          </div>
        </div>
        <div class="quality-text">{{ currentQuality.name }}</div>
      </div>
      <!-- 全屏 -->
      <div class="playback-fullscreen">
        <Icon
          v-if="!fullscreen"
          type="md-qr-scanner"
          title="全屏"
          @click="toggleFullScreen" />
        <Icon
          v-else
          type="md-contract"
          title="退出全屏"
          @click="toggleFullScreen" />
      </div>
      <!-- 切换 -->
      <div v-if="!isVideo" class="playback-switch">
        <Icon type="md-repeat" title="切换" @click="pptVideoSwitch" />
      </div>
      <!-- <div v-if="isVideo" class="playback-switch">
          <Icon type="md-repeat" title="切换" @click="pptVideoSwitch" />
        </div> -->
    </div>
    <!-- 聊天在线交互区 -->
    <div class="live-interaction">
      <div class="tab-title">
        <div
          class="tab-switch"
          :class="{ 'tab-active': activeInterationTab === 'message' }"
          @click="setInterationTab('message')">
          <span
            class="tab-item"
            :class="{ active: activeInterationTab === 'message' }"
            >聊天</span
          >
        </div>
        <div
          v-if="!info.IsOnline"
          class="tab-switch"
          :class="{ 'tab-active': activeInterationTab === 'user' }"
          @click="setInterationTab('user')">
          <span
            class="tab-item"
            :class="{ active: activeInterationTab === 'user' }"
            >在线<label>({{ userCount }})</label></span
          >
        </div>
      </div>
      <div class="divider"></div>
      <!-- 公告内容 -->
      <div id="notice" class="notice">
        <div class="announcement-content"></div>
      </div>
      <div class="tab-container">
        <div
          id="message-panel"
          class="message-panel"
          :class="{ active: activeInterationTab === 'message' }">
          <div class="message-list" :class="{ playback: !living }"></div>
          <div v-if="living" class="message-sender"></div>
        </div>
        <div
          id="user-list"
          class="user-list"
          :class="{ active: activeInterationTab === 'user' }"></div>
        <div
          v-if="living && info.IsQuery"
          class="question-btn"
          @click="toggleQuestionAnswer">
          <Icon custom="ich-icon ich-icon-u-question" size="18" />
          <br />
          提问
        </div>
        <div
          id="question-answer"
          class="question-answer"
          :class="{ expand: questionAnswerExpand }">
          <div class="question-answer-bar">
            <span class="title">
              <Icon custom="ich-icon ich-icon-u-question" size="16" />
              问答</span
            >
            <span class="toogle" @click="toggleQuestionAnswer">X</span>
          </div>
          <div class="placeholder"></div>
        </div>
      </div>
      <div class="speak-apply">
        <div id="speak-apply">连麦</div>
      </div>
    </div>
  </div>
</template>
<script>
import { siteMixin } from '../../utils/mixin';
import { userRoleMap } from '../../utils/live';
const store = BJY.store;
const auth = BJY.auth;
const eventEmitter = BJY.eventEmitter;
// let player = null;
let notice = null;
export default {
  name: 'LiveCollectIndex',
  mixins: [siteMixin],
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    playback: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      activeInterationTab: 'message',
      switchPptVideo: false,
      isVideo: false,
      forbidChange: true,
      pageData: null,
      canPrePage: true,
      canNextPage: true,
      userCount: 1,
      questionAnswerExpand: false,
      living: true, //true直播中，false为回放
      isPlaying: false,
      showVolumeSlider: false,
      currentSpeed: 1,
      qualityList: [],
      currentQuality: {},
      fullscreen: false,
      duration: 0,
      durationTime: 0,
    };
  },
  created() {
    this.isVideo = this.info.mockLive === 2;
    if (this.playback && Object.keys(this.playback).length) {
      this.living = false;
      this.qualityList = this.playback.definition;
      this.currentQuality = this.qualityList.find(
        m => m.type === this.playback.defaultDefinition,
      );
    } else {
      this.living = true;
    }
  },
  mounted() {
    this.init();
    this.noticeFn();
  },
  async beforeDestroy() {
    if (bplayer) {
      await bplayer.destroy();
      bplayer = null;
    }
    notice && notice.destroy();
  },
  methods: {
    init() {
      // if (this.isVideo) {
      this.initWhiteboard();
      // }
      if (this.living) {
        this.initTeacherPlayer();
        this.initQuestionAnswer();
      } else {
        this.initPlaybackPlayer();
      }
      if (this.info.IsMarquee) {
        this.initHorseLamp();
      }
      this.initInteration();

      // 用于回放全屏处理
      if (!this.living) {
        window.addEventListener('fullscreenchange', event => {
          if (!document.fullscreenElement) {
            this.fullscreen = false;
          }
        });
      }
    },
    initWhiteboard() {
      if (this.whiteboard) {
        this.whiteboard.destroy();
        this.whiteboard = null;
      }
      this.whiteboard = BJY.Whiteboard.create({
        element: $('#whiteboard').find('.placeholder'),
        fit: 1,
      });

      eventEmitter.on(eventEmitter.STUDENT_PPT_AUTH_CHANGE, (e, data) => {
        // console.log('data.forbid', data.forbid);
        this.forbidChange = data.forbid;
      });
    },
    setPageData() {
      this.pageData = BJY.data.page;
      this.canPrePage = this.pageData.getClientPage() > 0;
      this.canNextPage =
        this.pageData.getClientPage() < this.pageData.getMaxPage();
      // console.log(
      //   'aaa',
      //   this.pageData.getClientPage(),
      //   this.pageData.getMaxPage()
      // );
    },
    pagePrevTrigger() {
      if (!this.canPrePage) return;
      eventEmitter.trigger(eventEmitter.PAGE_PREV_TRIGGER);
      // this.setPageData();
    },
    pageNextTrigger() {
      if (!this.canNextPage) return;
      eventEmitter.trigger(eventEmitter.PAGE_NEXT_TRIGGER);
      // this.setPageData();
    },
    initTeacherPlayer() {
      this.createTeacherPlayer();
      // eventEmitter.on(
      //   eventEmitter.CLASSROOM_CONNECT_SUCCESS,
      //   (event, data) => {}
      // );
    },
    createTeacherPlayer(isWebRTCMix) {
      // console.log('init player start');
      if (typeof isWebRTCMix === 'undefined') {
        isWebRTCMix = auth.isWebRTC();
      }
      isWebRTCMix && (store.get('webrtcMixUser').name = '老师');
      this.player && this.player.destroy();
      this.player = null;
      const user = auth.isPresenter()
        ? store.get('presenter')
        : isWebRTCMix
        ? store.get('webrtcMixUser')
        : store.get('presenter') || store.get('teacher');
      let extension = BJY.getExtension();
      if (BJY.browser.wechat) {
        extension = BJY.Player.html;
      }
      const options = {
        element: $('#teacher-player'),
        replace: false,
        user: user,
        extension: extension,
        canSwitchCamera: auth.isSelf(store.get('teacher.id')),
        canSwitchMic: auth.isSelf(store.get('teacher.id')),
        canFullScreen: true,
        footerOptions: {},
      };
      options.footerOptions = {
        onToggleClick: this.pptVideoSwitch,
      };
      // if (this.isVideo) {
      //   options.footerOptions = {
      //     onToggleClick: this.pptVideoSwitch,
      //   };
      // }
      !auth.isTeacher() && (options.isWebRTCMix = isWebRTCMix);
      this.player = BJY.DefaultThemePlayer.create(options);
    },
    // 回放播放器处理
    initPlaybackPlayer() {
      store.set('isPlaying', false);
      this.loadPlaybackPlayer();
      // //播放事件处理
      bplayer.on('ready', () => {
        console.log('ready');
        this.initPlaybackSlider();
        BJY.playback.start(0);

        setTimeout(() => {
          // bplayer.seek(this.duration); //seek播放位置--不生效，兼容性问题至今未解决
          this.$emit('getDuration', 100);
        }, 200);
      });
      bplayer.on('first_play', () => {
        console.log('first_play');
        BJY.playback.play();
        store.set('isPlaying', true);
      });
      bplayer.on('play', () => {
        console.log('play');
        store.set('isPlaying', true);
      });
      bplayer.on('playing', () => {
        console.log('playing');
        BJY.playback.play();
        store.set('isPlaying', true);
      });

      bplayer.on('pause', () => {
        console.log('pause');
        BJY.playback.pause();
        store.set('isPlaying', false);
      });
      bplayer.on('ended', () => {
        console.log('ended');
        store.set('isPlaying', false);
        bplayer.pause();
      });
      bplayer.on('seeked', ({ seekFrom, seekTo }) => {
        BJY.playback.seek(seekTo);
        BJY.playback.play();
      });
      bplayer.on('full_screen_change', function (isFullScreen) {
        if (hasSubtitles) {
          isFullScreen
            ? $('.bplayer-wrap').append($('.bplayer-subtitle'))
            : $('.left-panel') &&
              $('.left-panel').append($('.bplayer-subtitle'));
        }
      });
      bplayer.on('timeupdate', time => {
        BJY.playback.timeupdate(time);
      });
    },
    // 装载播放器
    loadPlaybackPlayer(quality) {
      // 播放数据处理
      const data = this.playback;
      if (!data || !data.videos) {
        this.$Message.error('获取回放视频信息失败!');
        return;
      }

      quality = quality || data.defaultDefinition;
      let url = data.videos[quality][0].url;
      // let type = data.videos[quality][0].format;
      let poster = data.videos[quality][0].poster;
      this.durationTime = data.videos[quality][0].duration;
      url = url.replace('https:', '').replace('http:', '');
      if (!window.bplayer) {
        window.bplayer = new BPlayer({
          container: document.getElementById('bplayer-container'),
          useFFplayerMSE: false,
          // currentTime:  this.duration, // 视频播放时间
          video: {
            url,
          },
          poster,
          enableDrag: true,
        });
        store.set('teacherVideo', bplayer);
      } else {
        let memoryTime = window.bplayer.currentTime;
        window.bplayer.changeVideo(url);
        setTimeout(() => {
          window.bplayer.seek(memoryTime);
          store.set('isPlaying', true);
        }, 1000);
      }

      // if (url.indexOf("ev1") > -1 && window.flvjs) {
      //   // 使用flvjs 播放加密格式视频
      //   // 如果已经存在拉流则先销毁原流
      //   if (player) {
      //     player.destroy();
      //   }
      //   player = window.flvjs.createPlayer(
      //     {
      //       type: "ev1",
      //       url: url,
      //       cors: true,
      //     },
      //     {
      //       stashInitialSize: 1024,
      //     }
      //   );
      //   player.attachMediaElement(this.videoEl);
      //   player.load();
      // } else {
      //   this.videoEl.src = url;
      // }
      // if (currentTime) this.videoEl.currentTime = currentTime;
      // if (this.isPlaying) {
      //   this.videoEl.play();
      // }
    },
    // 回放控制条
    initPlaybackSlider() {
      const teacherVideo = store.get('teacherVideo');
      // 进度条
      const playerSlider = BJY.NewPlayerSlider.create({
        element: $('#playback-playslider'),
        replace: false,
        currentTime: this.duration || 0, // 视频播放时间
        duration: +teacherVideo.duration || this.durationTime,
        canUseHotKey: true, // 是否支持快捷键
        markDot: this.markDot, // 标记点
        onBeforeDrag: () => {
          // <-- 建议在此暂停视频播放 -->
          // teacherVideo.pause();
        },
        slideAnimation: style => {
          // <-- 可在此做滑动效果 -->
        },
        onAfterDrag: time => {
          // <-- 建议在此播放视频时间为 time -->
          // teacherVideo.currentTime = time;
          teacherVideo.seek(time);
          setTimeout(() => {
            teacherVideo.play();
          }, 500);
        },
        onBeforeSeek: time => {
          // <-- 建议在此暂停视频播放 -->
          // teacherVideo.pause();
        },
        onAfterSeek: time => {
          // <-- 建议在此播放视频时间为 time -->
          // teacherVideo.currentTime = time;
          // teacherVideo.seek(time)
          setTimeout(() => {
            teacherVideo.play();
          }, 500);
        },
        onBeforeBackward: () => {
          // <-- 快退之前，建议在此暂停视频播放 -->
          teacherVideo.pause();
        },
        onAfterBackward: time => {
          // time 是快退之后选中的时间 单位：s
          // <-- 快退之后，建议在此播放视频时间为 time -->
          // teacherVideo.currentTime = time;
          // teacherVideo.play();
          teacherVideo.seek(time);
          setTimeout(() => {
            teacherVideo.play();
          }, 500);
        },
        onBeforeForward: () => {
          // <-- 快进之前，建议在此暂停视频播放 -->
          // teacherVideo.pause();
        },
        onAfterForward: time => {
          // time 是快退之后选中的时间 单位：s
          // <-- 快进之后，建议在此播放视频时间为 time -->
          // teacherVideo.currentTime = time;
          // teacherVideo.play();
          teacherVideo.seek(time);
          setTimeout(() => {
            teacherVideo.play();
          }, 500);
        },
        onSpacePress: () => {
          // <-- 建议在此判断视频的播放状态 当前为暂停就开始播放 当前为播放就暂停 -->
          teacherVideo.paused ? teacherVideo.play() : teacherVideo.pause();
        },
      });
      // 必须监听视频的timeupdate事件，来告诉回放去根据视频时间更新数据
      teacherVideo.on('timeupdate', () => {
        playerSlider &&
          playerSlider.set('currentTime', teacherVideo.currentTime);
      });
      store.watch('isPlaying', isPlaying => {
        this.isPlaying = isPlaying;
      });
      // 音量 playback-volume
      BJY.VolumeSlider.create({
        element: $('#playback-volume'),
        replace: false,
        min: 0,
        max: 100,
        value: 80, // 默认音量
        onChange: value => {
          // <!-- 音量改变的时候触发，请在此处修改您的视频音量 -->
          store.set('teacherVideo.volume', value / 100);
        },
      });
    },
    togglePlay() {
      bplayer.paused ? bplayer.play() : bplayer.pause();
    },
    toggleVolumeSlider() {
      this.showVolumeSlider = !this.showVolumeSlider;
    },
    // 切换倍速
    switchSpeed(speed) {
      this.currentSpeed = speed;
      if (!window.bplayer) return;
      window.bplayer.setSpeed(speed);
      // if (store.get("teacherVideo")) {
      //   store.set("teacherVideo.playbackRate", speed || 1);
      // }
    },
    // 切换清晰度
    switchQuality(quality) {
      this.currentQuality = quality;
      this.loadPlaybackPlayer(quality.type);
    },
    toggleFullScreen() {
      const domEl = document.getElementById('live-main');
      if (this.fullscreen) {
        this.fullscreen = false;
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      } else {
        if (domEl.requestFullscreen) {
          domEl.requestFullscreen();
        }
        setTimeout(() => {
          this.fullscreen = true;
          setTimeout(() => {
            eventEmitter.trigger(eventEmitter.WINDOW_RESIZE);
          }, 200);
        }, 300);
      }
    },
    pptVideoSwitch() {
      this.switchPptVideo = !this.switchPptVideo;
      setTimeout(() => {
        // this.initInteration();
        eventEmitter.trigger(eventEmitter.WINDOW_RESIZE);
        window.bplayer.resize();
      }, 100);
    },
    setInterationTab(tab) {
      this.activeInterationTab = tab;
    },
    initInteration() {
      // 消息 & 聊天列表;
      BJY.MessageList.create({
        element: $('#message-panel .message-list'),
        replace: false,
        // 加载表情 返回一个<img>标签
        renderEmoji: (name, url) => {
          if (BJY.isAlicloudImage(url)) {
            return (
              '<img ondragstart="return false" src="' +
              (url + '@100w_1e_1l.png') +
              '" srcset="' +
              (url + '@200w_1e_1l.png') +
              ' 2x">'
            );
          }
          return '<img ondragstart="return false" src="' + url + '">';
        },
        renderUser: (user, width, height) => {
          return {
            id: user.id,
            name: user.name,
            number: user.number,
            // 低密度屏幕压缩，详情查看基础第二条
            avatar: BJY.compressImage({
              url: user.avatar,
              // 对于低密度屏幕将图片压缩到头像的大小
              width: width,
              height: height,
            }),
            // 高密度屏幕压缩，详情查看基础第二条
            avatar2x: BJY.compressImage({
              url: user.avatar,
              // 对于高密度屏幕（如 MAC）将图片压缩到头像的2倍大小
              width: width * 2,
              height: height * 2,
            }),
            // 根据用户类型，配置角色的英文语言
            role: userRoleMap[user.type].en,
            // 根据用户类型，配置角色的本地语言
            localRole: userRoleMap[user.type].cn,
          };
        },
        loadDistance: 0,
      });

      // 消息发送
      if (this.living) {
        BJY.MessageSender.create({
          element: $('#message-panel .message-sender'),
          replace: false,
          // 能否发送表情
          canSendEmoji: true,
          // 能否发送图片
          canSendImage: false,
          // 能否使用私聊功能，可选，默认为false
          canWhisper: false,
          canQuickReply: false,
          // 是否多行输入，在移动端浏览器下此项传false
          multiline: false,
          // 提示信息
          placeholder: '请输入...',
          // 设置最大字符数
          messageMaxLength: 140,
        });
      }

      // 在线用户列表
      if (!this.info.IsOnline) {
        BJY.UserList.create({
          element: $('#user-list'),
          replace: false,
          renderUser: (user, width, height) => {
            return {
              id: user.id,
              name: user.name,
              number: user.number,
              // 头像需压缩
              avatar: BJY.compressImage({
                url: user.avatar,
                width: width,
                height: height,
              }),
              avatar2x: BJY.compressImage({
                url: user.avatar,
                width: width * 2,
                height: height * 2,
              }),
              // 根据用户类型，配置角色的英文和本地语言
              role: userRoleMap[user.type].en,
              localRole: userRoleMap[user.type].cn,
            };
          },
        });
        // 监听人数变化
        eventEmitter.on(eventEmitter.USER_COUNT_CHANGE, (e, data) => {
          console.log('onUserCount', data.userCount);
          this.userCount = data.userCount;
        });
      }
    },
    initQuestionAnswer() {
      //问答
      BJY.QuestionAnswer.create({
        element: $('#question-answer .placeholder'),
        replace: false,
        // 是否能够管理问题，老师或者助教传入true，学生传入false，会依据这个参数创建不同视图的面板
        canManageQuestion: false,
        // 每分钟限制发送的次数，可不传，默认值为10
        limitPerMinute: 100,
        // 每页显示的条数，可不传，默认为50
        countPerPage: 50,
        // 输入框可输入的最大长度，可不传，默认为140
        inputMaxLength: 140,
        // 是否是滑动翻页，仅在移动端时可用！！默认为false
        pageBySwipe: false,
        // 复制完成时的回调
        onCopyFinish: () => {},
      });
    },
    toggleQuestionAnswer() {
      this.questionAnswerExpand = !this.questionAnswerExpand;
    },
    initHorseLamp() {
      const content = this.isLogin ? this.loginUser.userId.toString() : '0';
      const additionalStyle = `font-size: 10px; color:#fff; opacity:0.2`;
      const horseLamp = new BJY.HorseLamp({
        container: $('#live-main'),
        // 第一个跑马灯开始到下一个跑马灯开始的间隔
        timeout: 10,
        // 跑完一次到下一次开始的间隔
        interval: 5,
        // 轨道数
        trackCount: 8,
        // 跑马灯速度
        speed: 80,
        // 一次跑多少个
        count: 5,
        // 跑马灯模式 0- 轨道随机模式 1- 防盗录模式（可根据跑马灯来解析出学生信息）版本 0.3.0+ 可用
        mode: 0,
        // 第一个轨道距container top 的距离
        top: 0,
        // 最后一个轨道距container bottom 的距离
        bottom: 0,
        // 跑马灯内容
        content: content,
        additionalStyle: additionalStyle,
      });
      // 开始跑马灯
      horseLamp.start();
    },
    initSpeakApply() {
      // 绑定一个结束发言事件
      eventEmitter.STOP_SPEAK_TRIGGER = 'stop_speak_trigger';
      eventEmitter
        .on(eventEmitter.SPEAK_APPLY_RESULT_TIMEOUT, () => {
          this.$Message.error('老师未做响应，已自动取消申请发言');
        })
        .on(eventEmitter.SPEAK_APPLY_RESULT_REJECT, () => {
          this.$Message.error('老师拒绝了你的发言申请');
        })
        .on(eventEmitter.SPEAK_APPLY_RESULT_ACCEPT, () => {
          this.$Message.success('老师已允许你发言');
        })
        .on(eventEmitter.SPEAK_APPLY_FORBID_ALL_CHANGE, (e, data) => {
          if (!data.cache) return;
          if (data.forbidAll) {
            this.$Message.error('已禁止连麦');
          } else {
            this.$Message.success('已允许连麦');
          }
        });
      const userData = BJY.data.user;
      BJY.SpeakApplyMenu.create({
        element: $('#speak-apply'),
        replace: false,
        onApplyClick: () => {
          alert('onApplyClick');
          if (!store.get('class.started')) return;
          if (BJY.data.class.getForbidSpeakApply()) {
            this.$Message.error('已禁止连麦');
            return;
          }
          if (
            userData.active().length >= store.get('partner.liveMaxSpeakers')
          ) {
            this.$Message.error('当前上台人数已满');
            return;
          }
          BJY.userSpeak.startApply(10 * 1000);
        },
        // 取消举手被点击
        onCancelClick: () => {
          BJY.userSpeak.cancelApply();
        },
        // 结束发言被点击
        onStopClick: () => {
          BJY.userSpeak.stopSpeak(BJY.store.get('user.id'));
          eventEmitter.trigger(eventEmitter.STOP_SPEAK_TRIGGER);
          eventEmitter.trigger(eventEmitter.MEDIA_SWITCH_TRIGGER, {
            videoOn: false,
            audioOn: false,
          });
        },
      });
    },
    // 直播公告
    noticeFn() {
      notice = BJY.Notice.create({
        element: $('#notice .announcement-content'), // 父容器
        replace: true,
        defaultContent: '空~', // 默认无公告时显示文本
        maxLength: 140, // 公告文本最大长度
        contentPlaceholder: '请输入公告正文内容', // 公告文本编辑框提示
        linkPlaceholder: '请输入公告跳转链接（可选）', // 公告链接编辑框提示
        linkErrorHint: 'URL 格式错误', // url 错误提示
        foldDefault: false, // 公告是否默认折叠(默认折叠后新公告不会主动展开)
        onMaxLengthError: () => {
          // 超出最大长度回调
          alert('公告内容不能太长哦');
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.live-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow: hidden;
  //纯视频，无PPT
  &.video {
    .live-whiteboard {
      display: none;
    }
    .live-player {
      left: 0;
      width: calc(100% - 365px);
      height: 100%;
    }
    .live-interaction {
      top: 0;
      height: 100%;
    }
  }
  &.switch {
    .live-whiteboard {
      top: 0;
      right: 0;
      width: 360px;
      height: 250px;
    }
    .live-player {
      left: 0;
      top: 0;
      width: calc(100% - 365px);
      height: calc(100% - 2px);
    }
  }
  &.fullscreen.switch {
    .live-player {
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 2;
    }
  }
  &.fullscreen.default {
    .live-whiteboard {
      top: 0;
      right: 0;
      left: auto;
      width: 100%;
      height: 100%;
      z-index: 2;
    }
  }
  &.fullscreen {
    .playback-panel {
      width: 100%;
      z-index: 10;
    }
  }
}
.live-whiteboard {
  position: absolute;
  right: 365px;
  top: 0;
  width: calc(100% - 365px);
  height: 100%;
  background-color: #fff;
  .pre-page {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 50%;
    padding: 4px;
    text-align: center;
    color: #fff;
    font-weight: bold;
    border-right: 1px solid #ccc;
    background: rgba(0, 0, 0, 0.45);
    cursor: pointer;
  }
  .next-page {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 50%;
    padding: 4px;
    text-align: center;
    color: #fff;
    font-weight: bold;
    border-right: 1px solid #ccc;
    background: rgba(0, 0, 0, 0.45);
    cursor: pointer;
  }
  .forbid {
    cursor: not-allowed;
  }
}
.live-player {
  position: absolute;
  top: 0;
  right: 0;
  width: 360px;
  height: 250px;
  background: #fff;
  overflow: hidden;
  z-index: 1;
  // transition: all 0.3s ease;
  & > .bplayer-container {
    width: 100%;
    height: calc(100% - 4px);
    /deep/.bplayer-control-bar {
      display: none;
    }
  }
}
.playback-panel {
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  height: 40px;
  background: rgba(0, 0, 0, 0.65);
  z-index: 2;
  // width: 100%;
  width: calc(100% - 360px);
  .playback-play {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    color: #fff;
    font-size: 22px;
    & > i {
      cursor: pointer;
    }
  }
  .playback-slider {
    flex: 1;
  }
  .playback-volume {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    font-size: 22px;
    color: #fff;
    cursor: pointer;
    margin: 0 8px;
    & > .volume-slider {
      position: absolute;
      left: 0;
      bottom: 40px;
    }
  }
  .playback-speed {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 24px;
    margin: 0 4px;
    &:hover {
      .speed-text {
        background: rgba(1, 149, 211, 0.45);
      }
      .speed-list {
        display: block;
      }
    }
    .speed-text {
      width: 48px;
      height: 24px;
      line-height: 24px;
      background: rgba(0, 0, 0, 0.25);
      text-align: center;
      color: #fff;
      cursor: pointer;
      border-radius: 30px;
      font-size: 12px;
    }
    .speed-list {
      position: absolute;
      bottom: 22px;
      left: 0;
      display: none;
      padding-bottom: 16px;
      // background: #ff0;
      // display: none;
      width: 50px;
      & > .speed-item {
        width: 100%;
        // padding: 4px 0;
        background: rgba(0, 0, 0, 0.65);
        & > span {
          display: block;
          width: 100%;
          // height: 20px;
          // line-height: 20px;
          text-align: center;
          padding: 4px 0;
          font-size: 12px;
          color: #fff;
          cursor: pointer;
          user-select: none;
          &:hover {
            color: #0195d3;
          }
          &:nth-child(n + 2) {
            border-top: 1px solid #fff;
          }
        }
      }
    }
  }
  .playback-quality {
    position: relative;
    display: flex;
    // display: none;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 24px;
    margin: 0 4px;
    &:hover {
      .quality-text {
        background: rgba(1, 149, 211, 0.45);
      }
      .quality-list {
        display: block;
      }
    }
    .quality-text {
      width: 48px;
      height: 24px;
      line-height: 24px;
      background: rgba(0, 0, 0, 0.25);
      text-align: center;
      color: #fff;
      cursor: pointer;
      border-radius: 30px;
      font-size: 12px;
    }
    .quality-list {
      position: absolute;
      bottom: 22px;
      left: 0;
      display: none;
      padding-bottom: 16px;
      // background: #ff0;
      // display: none;
      width: 50px;
      & > .quality-item {
        width: 100%;
        // padding: 4px 0;
        background: rgba(0, 0, 0, 0.65);
        & > span {
          display: block;
          width: 100%;
          // height: 20px;
          // line-height: 20px;
          text-align: center;
          padding: 4px 0;
          font-size: 12px;
          color: #fff;
          cursor: pointer;
          user-select: none;
          &:hover {
            color: #0195d3;
          }
          &:nth-child(n + 2) {
            border-top: 1px solid #fff;
          }
        }
      }
    }
  }
  .playback-fullscreen {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    // margin-right: 4px;
    color: #fff;
    font-size: 22px;
    & > i {
      cursor: pointer;
    }
  }
  .playback-switch {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 40px;
    margin-right: 8px;
    color: #fff;
    font-size: 22px;
    & > i {
      cursor: pointer;
    }
  }
}
.live-interaction {
  position: absolute;
  top: 250px;
  right: 0;
  width: 360px;
  height: calc(100% - 245px);
  background-color: #fff;
  .tab-title {
    display: flex;
    justify-content: space-around;
    align-items: bottom;
    width: 100%;
    height: 45px;
    // border-bottom: 1px solid #ddd;
    // border-top: 1px solid #ddd;
    background: #1c1b1c;
    color: #ffffffa6;
    .tab-switch {
      margin-top: 6px;
      flex: 1;
      height: 39px;
      text-align: center;
      cursor: pointer;
      &.tab-active {
        border-radius: 20px 20px 0 0;
        background: #ffffff;
      }
    }
    .tab-item {
      padding: 8px 12px;
      margin-top: 1px;
      display: inline-block;
      text-align: center;
      border-bottom: 2px solid transparent;
    }
    .active {
      color: #2382fb;
      border-bottom: 2px solid #2382fb;
    }
  }
  .divider {
    width: 100%;
    height: 1px;
    background-color: #eeeeee;
  }
  .tab-container {
    position: relative;
    width: 100%;
    height: calc(100% - 40px);
    .message-panel,
    .user-list {
      width: 100%;
      height: 100%;
      opacity: 0;
      display: none;
      /deep/ .bjy-user-list {
        padding-top: 30px;
        .bjy-avatar-wrap {
          img {
            border-radius: 50%;
            border: 1px solid rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
    .message-panel {
      position: relative;
      .message-list {
        position: relative;
        width: 100%;
        height: calc(100% - 105px);
        &.playback {
          height: 100%;
        }
        /deep/ .bjy-message-list {
          padding-top: 30px;
        }
        /deep/ .bjy-avatar {
          img {
            border-radius: 50%;
            border: 1px solid rgba(0, 0, 0, 0.1);
          }
        }
      }
      .message-sender {
        position: relative;
        width: 100%;
        height: 80px;
        padding: 8px 12px;
        background-color: #fff;
      }
    }
    .active {
      display: block;
      opacity: 1;
    }
    .question-btn {
      position: absolute;
      right: 15px;
      bottom: 80px;
      width: 50px;
      height: 50px;
      padding: 4px 0;
      border-radius: 100px;
      color: #fff;
      text-align: center;
      background: linear-gradient(to right, #27a3ff, #2380fb);
      cursor: pointer;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
    }
    .question-answer {
      position: absolute;
      width: 100%;
      height: 0;
      bottom: 0;
      left: 0;
      box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.2);
      transition: all 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
      overflow: hidden;
      &.expand {
        height: 493px;
        transition: all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
      }
      &-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 36px;
        border-top: 1px solid #979797;
        border-bottom: 1px solid #979797;
        background-color: #fff;
        & > span {
          padding: 0 12px;
        }
        & > .toogle {
          cursor: pointer;
        }
      }
    }
  }
  .speak-apply {
    display: none;
    position: absolute;
    right: 10px;
    bottom: 10px;
    background-color: #0195d3;
    width: 100px;
    height: 100px;
  }
  .notice {
    position: absolute;
    top: 46px;
    left: 0;
    width: 100%;
    z-index: 1;
    background-color: #00000014;
    /deep/ .bjy-content {
      max-height: 15px;
    }
    /deep/ .bjy-text {
      color: #00000096;
    }
  }
}
</style>
